import React from 'react';
import HrnbInput from "./HrnbInput";
import HrnbTextArea from "./HrnbTextArea";
import '../../css/components/controls/HrnbFormControl.css'

export default function HrnbFormControl({
                                            icon,
                                            className = "",
                                            as = "text",
                                            type, // поддержка type для input
                                            value,
                                            onChange,
                                            placeholder = "",
                                            error = "",
                                            hint = "",
                                            label,
                                            children,
                                            ...props
                                        }) {
    if (as === "textarea") {
        return (
            <div className={`hrnb-form-control ${className}`}>
                {icon && <span className="hrnb-form-control__icon">{icon}</span>}
                {label && <label className="hrnb-form-control__label">{label}</label>}
                <HrnbTextArea
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    {...props}
                />
                {error && <div className="hrnb-form-control__error">{error}</div>}
                {hint && !error && <div className="hrnb-form-control__hint">{hint}</div>}
            </div>
        );
    } else {
        return (
            <div className={`hrnb-form-control ${className}`}>
                {icon && <span className="hrnb-form-control__icon">{icon}</span>}
                {label && <label className="hrnb-form-control__label">{label}</label>}
                <HrnbInput
                    className="hrnb-form-control__input"
                    type={type || as}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    {...props}
                />
                {error && <div className="hrnb-form-control__error">{error}</div>}
                {hint && !error && <div className="hrnb-form-control__hint">{hint}</div>}
            </div>
        );
    }
}